import {PageTypeEnum} from "@/entity/PageTypeEnum";

export default class PageEntity {
    page_id : number | undefined = undefined;
    seo_id : number = 1;
    type : PageTypeEnum | any ;
    name : string  = "";
    name_en : string = "";
    short_description : string   = "";
    short_description_en : string    = "";
    title_en:string ="";
    title:string ="";
    context_data:string="";
    context_data_en:string="";
}